export default __webpack_public_path__ + "static/media/elevate-red-4.4da2d0ee.png";